const store = require('store2');

export default ($container) => {
    // Hide all geolocation detection if not supported
    if (typeof navigator.geolocation !== 'object') {
        $('.js-geolocate').hide();
    }

    // Geolocation
    $('.js-geolocate', $container).on('click', function(e) {
        e.preventDefault();
        const $target = $($(this).data('geolocate-target'));
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const coordinatesAsText = `${position.coords.latitude} ${position.coords.longitude}`;
                store.set('geolocation', coordinatesAsText);
                if ($target.is(':input')) {
                    $target.val(coordinatesAsText).trigger('change');
                } else {
                    $target.text(coordinatesAsText);
                }
            }, () => {
                alert('Je hebt geen toestemming gegeven voor gebruik van je locatie');
            });
        } else {
            alert('Helaas, je browser heeft geen ondersteuning voor locatie detectie');
        }
    });
};
